import { css } from 'styled-components';

export const transparentButtonStyles = ($type: 'solid' | 'outline' | 'text', $dark?: boolean) => {
  return css`
    background: rgba(7, 7, 7, 0.32) !important;
    border: 0.1rem solid transparent;
    & > p {
      color: var(--normal);
    }
    & > svg path {
      stroke: var(--normal);
    }
    &:hover {
      background: ${$dark ? 'rgba(203, 203, 207, 0.24)' : 'rgba(139, 139, 147, 0.24)'};
    }
    &:active {
      background: ${$dark ? 'rgba(7, 7, 7, 0.32)' : 'rgba(254, 254, 254, 0.32)'};
    }
    &.selected {
      background: var(--pri-blue-1);
    }
    &:disabled {
      background: transparent;
      & > p {
        color: var(--bg-gray-2);
      }
      & > svg path {
        stroke: var(--bg-gray-2);
      }
    }
  `;
};
